import { CustomerTrackingData } from '@jbhi-fi/components/src/Tracking';

export const getCustomerId = (): string | undefined => {
  return window.Jbhifi?.customerId;
};

export const getHashedCustomerEmail = (): string | undefined => {
  return window.Jbhifi?.hashedCustomerEmail;
};

export const getCustomerTrackingData = (): CustomerTrackingData => {
  const address = window.Jbhifi?.addresses?.find(address => address.default);

  return {
    userId: getCustomerId(),
    isLoggedIn: window.Jbhifi?.customerDetails?.isLoggedIn,
    hashedEmail: getHashedCustomerEmail(),
    hashedPhone: address?.hashedPhone,
    postcode: address?.zip,
    state: address?.provinceCode,
  };
};
